import { createStore, combineReducers } from 'redux';
import authentication from '../_reducers/authentication.reducer';
import loaderReducer from '../_reducers/loader.reducer';
import serviceTypeReducer from '../_reducers/serviceType.reducer';
import userProfileReducer from '../_reducers/userProfile.reducer';
import adminRoleReducer from '../_reducers/adminRole.reducer';
import { persistStore, persistReducer } from 'redux-persist';
import Cookies from 'cookies-js';
import storage from 'redux-persist/lib/storage';
const rootReducer = combineReducers({authentication, loaderReducer, userProfileReducer, serviceTypeReducer, adminRoleReducer})
Cookies.defaults = {
    path: '/',
    secure: true,
    httpOnly: true,
};
const persistConfig = {
key: 'root',
storage: storage,
// blacklist: ['loaderReducer', 'userProfileReducer']
// storage:  new CookieStorage(Cookies),
};
const pReducer = persistReducer(persistConfig, rootReducer);
export const store = createStore(pReducer, undefined)
export const persistor = persistStore(store, {})
export default store;